import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../../data";
import { fadeUp, stagger, viewportOnce, viewportSome } from "../../lib/motion";

export const Testimonials = () => (
  <section data-testid="testimonials" className="relative bg-ink py-24 sm:py-32 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 mb-14 sm:mb-20">
        <div>
          <div className="overline mb-6">Ellos ya lo vivieron</div>
          <h2 className="font-display font-light text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Historias que <em className="italic text-ember">vuelven a elegirnos</em>
          </h2>
        </div>
        <div className="shrink-0">
          <div className="flex items-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-current" style={{ color: "var(--ember)" }} />
            ))}
          </div>
          <p className="font-display font-light text-4xl leading-none">
            10<span className="text-ember">/</span>10
          </p>
          <p className="font-body text-xs uppercase tracking-[0.2em] text-[var(--muted)] mt-1">viajeros repiten</p>
        </div>
      </motion.div>

      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportSome} className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={i}
            data-testid={`testimonial-${i}`}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportSome}
            className="group relative bg-ink-2 border border-white/10 p-8 sm:p-10 hover:border-white/25 transition-colors duration-500"
          >
            <Quote className="h-7 w-7 mb-6" style={{ color: "var(--ember)" }} />
            <blockquote className="font-display italic font-light text-xl sm:text-2xl leading-snug text-[var(--paper)]/90">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4">
              <img
                src={t.photo}
                alt={t.author}
                className="h-12 w-12 rounded-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 ring-1 ring-white/15"
              />
              <div>
                <p className="font-body font-semibold text-sm text-[var(--paper)]">{t.author}</p>
                <p className="font-body text-xs uppercase tracking-[0.15em] text-[var(--muted)]">{t.trip}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </motion.div>
    </div>
  </section>
);
